import React, {useEffect, useState} from 'react';
import Aux from '../../hoc/Aux/Aux';
import ProjectListItemPlaceholder
    from '../../components/UI/Placeholder/ProjectListItemPlaceholder/ProjectListItemPlacholder';
import CallToActionPlaceholder from "../../components/UI/Placeholder/CallToActionPlaceholder/CallToActionPlaceholder";
import ProjectListItem from './ProjectListItem/ProjectListItem';
import ProjectListCounter from './ProjectListCounter/ProjectListCounter';
import CallToAction from '../../components/CallToAction/CallToAction';
import styles from './ProjectList.module.scss';
import axios from '../../axios-base';
import {Link, useLocation, useHistory} from 'react-router-dom';
import {Row, Col, Input, Label} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSearch} from '@fortawesome/free-solid-svg-icons';
import FormInput from '../../components/UI/Input/FormInput';
import {sendVirtualPageView} from '../../shared/utility';
import qs from 'qs';
import {Helmet} from "react-helmet";

function ProjectListHook(props) {

    const [projectsCount, setProjectsCount] = useState(0);
    const [projects, setProjects] = useState(null);
    const [phrase, setPhrase] = useState('');
    const [categoryOptions, setCategoryOptions] = useState(null);
    const [categorySelected, setCategorySelected] = useState('');
    const [cta, setCta] = useState(null);
    const [inputSelection, setInputSelection] = useState(true);

    let history = useHistory();
    const location = useLocation();

    useEffect(() => {
        const cta = axios.get('/cta/', {params: {page: 'projekte'}})
        const options = axios.get('/options/')

        Promise.all([cta, options]).then(([resCta, resOptions]) => {
            setCta(resCta.data[0]);

            let availableCategories = resOptions.data[0].projectForm.projectCategory;
            if (availableCategories && availableCategories.elementConfig.options.length > 1) {
                let firstOption = () => {
                    if (availableCategories.dependent) {
                        return {value: "", displayValue: "Alle"}
                    } else {
                        return {
                            value: "",
                            displayValue: "Wähle eine " + availableCategories.elementConfig.label,
                            disabled: true
                        }
                    }
                }
                availableCategories.elementConfig.options.unshift(firstOption());
                availableCategories.elementConfig.label = "Wähle eine " + availableCategories.elementConfig.label;
                setCategoryOptions(availableCategories);
            }
        }).catch((error) => {
            console.log(error);
        });
        sendVirtualPageView("Teilnehmer");
    }, []);

    useEffect(() => {
        const query = qs.parse(location.search.slice(1)).category;
        setProjects(null);
        axios.get(`/projects/?category=${query}`)
            .then(response => {
                setProjects(response.data);
                setProjectsCount(response.data.length);
                setCategorySelected(query !== undefined ? query : "");
                setInputSelection(true);
            })
            .catch(error => {
                console.log(error);
            });
    }, [location])


    const categoryHandler = (e) => {
        const selectedCategory = e.target.value;
        setPhrase('');
        setInputSelection(false);
        if (selectedCategory !== categorySelected) {
            setCategorySelected(selectedCategory);
            history.push({
                search: `?category=${selectedCategory}`
            });
        }
    };

    const onChangeHandler = (e) => {
        setPhrase(e.target.value);
        if (categorySelected !== '' && categoryOptions.dependent) {
            setCategorySelected('');
            history.push({
                search: `?category=`
            });
        }
    };

    let categoryForm;
    if (categoryOptions) {
        categoryForm = (<FormInput
                wrapperCSSClass='category-select mb-3'
                elementType={categoryOptions.elementType}
                elementConfig={categoryOptions.elementConfig}
                value={categorySelected}
                changed={(e) => categoryHandler(e)}
                disabled={!inputSelection}
                shouldValidate={categoryOptions.valid}
                helperText={`${categoryOptions.elementConfig.label}. Wie z.B. ${categoryOptions.elementConfig.options[1].displayValue} oder ${categoryOptions.elementConfig.options[2].displayValue}`}/>
        );
    }

    let projectsRender = (
        <Aux>
            <ProjectListItemPlaceholder/>
            <ProjectListItemPlaceholder/>
            <ProjectListItemPlaceholder/>
        </Aux>
    );

    if (props.votingPhases.type && projects) {
        projectsRender = projects
            .filter((project) => {
                // @todo: Filter is associated with phases, therefore it can move up component hierarchy to app.js or be encompassed in the following reduce method
                if (props.votingPhases.type.length > 1) {
                    //we have a 2 part campaign
                    if (props.votingPhases.voteStartedFinale) {
                        return project.isFinalist;
                    } else {
                        return project;
                    }
                } else {
                    //global
                    return project;
                }

            })
            .filter(project => (project.contestantName.toLowerCase() + (project.projectTitle ? " " + project.projectTitle.toLowerCase() : ""))
                .includes(phrase.toLowerCase()))
            .reduce((displayedProjects, project) => {
                let projectVoteCount = '-';
                let projectRank = '-';
                if (props.votingPhases.type.length > 1) {
                    // @todo: We can move the project rank check out of the phase check as it is repeated for both phases
                    if (props.votingPhases.voteStartedFinale) {
                        if (project.voteCountFinale) {
                            projectVoteCount = project.voteCountFinale;
                            projectRank = project.rank;
                        }
                    } else {
                        if (props.votingPhases.voteStarted && project.voteCount) {
                            projectVoteCount = project.voteCount;
                            projectRank = project.rank;
                        }
                    }
                } else {
                    // @Todo: We can remove voteStartedFinale since this is now redundant? Potential refactor needed
                    if (props.votingPhases.voteStartedFinale && project.voteCountFinale) {
                        projectVoteCount = project.voteCountFinale;
                        projectRank = project.rank;
                    }
                }

                let projectLink = (// Todo: Deep-Link zur Ressource definieren und Pretty-Link erstellen
                    <Link className={`${styles.ProjectListLink} text-decoration-none anl_project-list--project-lnk`}
                          to={'./' + project._id} key={project._id}>
                        <ProjectListItem
                            rank={projectRank}
                            title={project.contestantName}
                            subtitle={project.projectTitle}
                            voteCount={projectVoteCount}
                            aria-hidden={true}
                        />
                        <p className="visually-hidden">
                            {`Platz ${projectRank}: ${project.contestantName}${project.projectTitle ? " (" + project.projectTitle + ")" : ""} mit ${projectVoteCount} Stimmen`}
                        </p>
                    </Link>);
                displayedProjects.push(projectLink);
                return displayedProjects;
            }, []);
    }

    let ctaRender = <CallToActionPlaceholder/>;

    if (cta) {
        ctaRender = <CallToAction
            btnClass={`anl_cta--${cta.page}--btn-${cta.position}`}
            headline={cta.headline}
            copy={cta.copy}
            buttonText={cta.buttonText}
            buttonColor={cta.buttonColor}
            linkUrl={cta.linkUrl}
            outline={cta.outline}
            buttonVisibility={cta.buttonVisibility}
        />
    }

    return (
        <Aux>
            <Helmet>
                <title>{`Teilnehmende | ${process.env.REACT_APP_PROJECT_TITLE}`}</title>
            </Helmet>

            {/* CallToAction */}
            <Row className="my-3">
                <Col>
                    {ctaRender}
                </Col>
            </Row>
            <Row className={styles.ProjectListCounterContainer + " bg-light pt-3 p-0 border-top border-bottom"}>
                {categoryForm}
                <Col className="project-search">
                    <FormInput disabled={!inputSelection}
                               changed={onChangeHandler}
                               inlineIcon={faSearch}
                               label="Teilnehmende suchen"
                               elementConfig={{
                                   label: "Teilnehmende suchen",
                                   placeholder: "Musterverein e.V.",
                                   type: "search"
                               }}
                               elementType="search"
                               helperText="Freitextsuche nach einem Teilnehmenden"
                               value={phrase}/>
                </Col>
            </Row>
            <Row className="my-3">
                <ProjectListCounter
                    projectsCount={projectsCount}
                    categories={categoryOptions}/>
            </Row>
            <Row>
                <Col className={styles.ProjectResults + " px-0 min-vh-100"}>
                    {projectsRender}
                </Col>
            </Row>
        </Aux>);

}

export default ProjectListHook;
